import { wsClient } from '../../util/appUtils';

class WizardService {
  static async getState(shopId, wizardType) {
    return wsClient.prepareRequest('GET', `system/wizard/${wizardType}/${shopId}/state`);
  }

  static async init(shopId, wizardType, initialData = {}) {
    return wsClient.prepareRequest('POST', `system/wizard/${wizardType}/${shopId}/state`, {
      body: { wizardData: initialData },
    });
  }

  static async updateStep(shopId, wizardType, stepId, stepIndex, stepData) {
    return wsClient.prepareRequest('PUT', `system/wizard/${wizardType}/${shopId}/step/${stepId}`, {
      body: { stepIndex, stepData },
    });
  }

  static async setCurrentStep(shopId, wizardType, stepIndex) {
    return wsClient.prepareRequest('PUT', `system/wizard/${wizardType}/${shopId}/current-step`, {
      body: { stepIndex },
    });
  }

  static async complete(shopId, wizardType) {
    return wsClient.prepareRequest('POST', `system/wizard/${wizardType}/${shopId}/complete`);
  }

  static async skip(shopId, wizardType) {
    return wsClient.prepareRequest('POST', `system/wizard/${wizardType}/${shopId}/skip`);
  }

  static async reset(shopId, wizardType) {
    return wsClient.prepareRequest('DELETE', `system/wizard/${wizardType}/${shopId}/state`);
  }

  static async getAvailableExperiences(shopId) {
    return wsClient.prepareRequest('GET', `system/wizard/${shopId}/experiences`);
  }
}

export default WizardService;
